<template>
  <div>
    <div class="myInfo" @click="ChangeInfo">
      <div class="info1" @click="GetHighAvatar($event)">
        <avatar username="Birth Circle"
                :src="localAvatar"
                :size="70">
        </avatar>
      </div>
      <div class="info4">
        <span style="visibility: hidden">1</span>
      </div>
      <div class="info2">
        <div v-if="user"><span style="font-size: 1.4rem;color: black">{{ user.userName }}</span></div>
        <div style="margin-top: 0.5rem" v-if="user"><span style="font-size: 1rem;color: gray">帐号：{{
            user.account
          }}</span></div>
      </div>
      <div class="info3">
        <img src="../../../assets/images/32/right_arrow.png" alt="">
      </div>
    </div>
    <div class="spdiv"></div>
    <div class="menudiv" style="background-color: whitesmoke">
      <div>
        <Cell title="生日管理" to="/m_bmanager" class="cellstyle" is-link>
          <img slot="icon" src="../../../assets/images/32/birthday_manager.png" width="24" height="24" alt="">
        </Cell>
      </div>
      <div>
        <Cell title="圈子管理" class="cellstyle" to="/m_circle_manager" is-link>
          <img slot="icon" src="../../../assets/images/32/circle_manager.png" width="24" height="24" alt="">
        </Cell>
      </div>
      <div style="margin-top: 1rem;">
        <Cell title="系统设置" to="/m_setting" class="cellstyle" is-link>
          <img slot="icon" src="../../../assets/images/32/system_setting.png" width="24" height="24" alt="">
        </Cell>
      </div>
    </div>
    <Popup style="width: 100%"
           v-model="popupVisible"
           popup-transition="popup-fade">
      <div :style="{'width':width+'px','height':height}" v-if="user">
        <img :style="{'width':width,'height':height}" :src="user.hightAvatarUrl" alt=""
             ref="highrImg">
      </div>
    </Popup>
  </div>
</template>

<style lang="less" scoped>
.myInfo {
  width: 100%;
  height: 100px;
}

.info1 {
  float: left;
  width: 20%;
  position: relative;
  margin-left: 1rem;
  background-color: white;
  top: 50%;
  transform: translateY(-50%);
}

.info4 {
  float: left;
  width: 6%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  text-align: left;
}

.info2 {
  float: left;
  width: 55%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  text-align: left;

  div {
    float: top;
  }
}

.info3 {
  float: left;
  width: 10%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  text-align: left;
}

.spdiv {
  height: 1rem;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  background-color: whitesmoke;
}

.holder {
  display: block;
  margin-left: 1rem;
  border-radius: 2rem;
  background-color: whitesmoke;
}

.logoutButton {
  background-color: red;
  color: black;
}

.menudiv {
  margin-left: -0.5rem;
  margin-right: -0.5rem;

  .cellstyle {
    text-align: left;
  }
}
</style>

<script>
import Avatar from "vue-avatar";
import {Cell, Popup} from 'mint-ui';

export default {
  name: "Mine",
  components: {
    Avatar,
    Cell, Popup
  },
  data() {
    return {
      localAvatar: null,
      width: null,
      height: null,
      popupVisible: false,
      user: {
        userName: null,
        account: null,
        avatarUrl: null,
        hightAvatarUrl: null,
        sex: null,
        date: null,
        time: null,
        dateType: true,
        remarks: null,
      },
      yhnm: localStorage.getItem('yhnm'),
      token: localStorage.getItem('token'),
      getUserInfoUrl: '/api/user/getUserInfo',
    }
  },
  mounted() {
    this.localAvatar = localStorage.getItem("localAvatar")//获取本地缓存头像
    this.user = JSON.parse(localStorage.getItem("user"))
    if (this.$route.params.refresh) {
      this.$router.go(0)
    }
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    //异步执行,单张图片转Base64
    imageUrlToBase64() {
      //一定要设置为let，不然图片不显示
      let image = new Image();
      //解决跨域问题
      image.crossOrigin = 'anonymous';
      //image.crossOrigin = ""
      //image.crossOrign = "*"
      image.src = this.user.avatarUrl
      //image.onload为异步加载
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);

        const quality = 1;
        //这里的dataurl就是base64类型
        const dataURL = canvas.toDataURL("image/jpeg", quality);//使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
        if (localStorage.getItem("localAvatar") === null) {
          this.localAvatar = this.user.avatarUrl
        }
        localStorage.setItem("localAvatar", dataURL)
      }
    },
    getUserInfo() {
      let that = this;
      this.$ajax({
        method: 'get',
        url: this.getUserInfoUrl,
        params: {yhnm: this.yhnm},
        headers: {token: this.token}
      }).then((response) => {
        if (response.data.result) {
          this.user = response.data['responseData']
          if (this.user.avatarUrl === null) {
            const data = require('/public/config/data.json')
            this.user.avatarUrl = data['defaultAvatarUrl']
            this.user.hightAvatarUrl = data['defaultAvatarUrl']
          }
          this.imageUrlToBase64();
          let user_json = JSON.stringify(this.user)
          localStorage.setItem("user", user_json)
        } else {
          that.$messagebox.alert(response.data.message)
        }
      }).catch(response => {
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    ChangeInfo() {
      this.$router.push('/m_myinfo');
    },
    GetHighAvatar(ev) {
      let clientw = document.body.clientWidth + 20
      let width = clientw + "px"
      this.height = this.width = width
      this.popupVisible = true
      ev.stopPropagation()
    }
  }
}
</script>
